import React from "react";
import { Card, Form, Col, Row, Container} from "react-bootstrap";
import { capitalizeFirstLetter } from '../../components/JobApplication/Shared/Helpers';
import Lottie from "react-lottie";
function OnlineInductionSuccessPage(props) {

    return (
        <Container fluid>
            <Row>
                <Col md={{ span: 6, offset: 3 }} sm={12} className="text-center">
                    <Lottie
                        options={props.animationOptions}
                        height={450}
                        width={400}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={{ span: 8, offset: 2 }} sm={12} className="text-center">
                    <h2 className="saved-title">Online Induction Completed!</h2>
                    <hr className="dashed-line" />
                </Col>
            </Row>
            <Row>
                <Col md={{ span: 8, offset: 2 }} sm={12}>
                    <p className="saved-text">
                        Thank you for successfully completing your {props.inductionData.title}.
                    </p>
                </Col>
            </Row>
        </Container>
    );
}

export default OnlineInductionSuccessPage;
